import toast from 'react-hot-toast';
import { useQuery } from 'react-query';

import { PaymentInfoProps, fetchPaymentInfo } from '../utils/backend-api/updatePayment';

const UPDATE_PAYMENT_KEY = 'UPDATE_PAYMENT_KEY';

const usePaymentInfo = () => {
  const { data, isLoading } = useQuery<PaymentInfoProps>(
    UPDATE_PAYMENT_KEY,
    () => fetchPaymentInfo(),
    {
      onError: (error: { message: string; redirect_to?: string }) => {
        toast.error(error.message);
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
    }
  );
  return { data, isLoading };
};

export default usePaymentInfo;
